export default __webpack_public_path__ + "static/media/left.0464448d.svg";